export const MuiTextField = {
  styleOverrides: {
    root: {
      // textField-no-bg
      '&.textField-no-bg .MuiOutlinedInput-root': {
        '& fieldset': {
          backgroundColor: 'rgba(0,0,0,0)'
        },
        '&:hover fieldset': {
          border: '0'
        }
      }
    }
  }
}
